import { useState } from "react";
import { ILoginForm, S_AUTH_ERROR, S_AUTH_REQUEST } from "../managers/Auth";
import { FormConstructor } from "./FormConstructor";
import { Config, REQ_HOST } from "../Config";

export const LoginForm = () =>{
    const [form,setForm] = useState<ILoginForm>({
        login:"",
        password:"",
        remember:false,
    })

    const [hosts,setHost]=REQ_HOST.useRequest()
    const error = S_AUTH_ERROR.use([])
    const sendForm = () =>{
        S_AUTH_ERROR.invoke(null)
        S_AUTH_REQUEST.invoke(form);
    }


    return <FormConstructor onSubmit={()=>sendForm()} error={error} title={"Authenticate"} form={form} fieldsGroups={[
        {
            fields:[
                {
                    label:"Login",
                    name:"login",
                    type:"login",
                },
                {
                    label:"Password",
                    name:"password",
                    type:"password",
                },
               
                {
                    label:"Remember me",
                    name:"remember",
                    type:"checkbox",
                }

            ]
        }
    ]} />

}
